import changelog from "../../../../../pages/products/docs/changelog-products.json5";
import * as React from 'react';
export default {
  changelog,
  React
};